import React from 'react';
import { Reveal, SectionEyebrow, SectionTitle, Container } from './Primitives';
import { useLanguage } from '@/context/LanguageContext';
import { SITE } from '@/constants/testIds';

const Process = () => {
  const { t } = useLanguage();
  return (
    <section
      id="process"
      data-testid={SITE.sectionProcess}
      className="relative py-20 lg:py-32 bg-white"
    >
      <Container>
        <div className="max-w-2xl">
          <Reveal>
            <SectionEyebrow>{t.process.eyebrow}</SectionEyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <SectionTitle className="mt-4">{t.process.title}</SectionTitle>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 relative">
          {/* connecting line (desktop) */}
          <div
            aria-hidden
            className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00A651]/30 to-transparent"
          />
          {t.process.steps.map((step, i) => (
            <Reveal key={step.title} delay={i * 0.08}>
              <article
                data-testid={SITE.processStep}
                className="relative h-full bg-[#F7F8F5] rounded-2xl p-7 border border-[rgba(0,166,81,0.1)] hover:border-[rgba(0,166,81,0.35)] transition-all duration-300 overflow-hidden group hover:-translate-y-1"
              >
                <span
                  aria-hidden
                  className="absolute -top-6 -right-2 font-['Outfit'] font-bold text-[120px] leading-none text-[#00A651]/8 select-none pointer-events-none"
                >
                  {i + 1}
                </span>
                <div className="relative">
                  <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#00A651] text-white font-['Outfit'] font-bold">
                    {i + 1}
                  </div>
                  <h3 className="mt-5 font-['Outfit'] text-lg font-semibold text-[#0B0F0C]">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm text-[#5C5C5C] leading-relaxed">{step.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Process;
